import { Controller } from 'stimulus'
import debounce from '../plugins/debounce.js'
import addDelayedMouseover from '../plugins/addDelayedMouseover.js'

export default class extends Controller {
  // categoryForm - кнопки открытия категории
  // categoryFrame - turbo-frame с панелью категории
  static targets = [ 'categoryFrame', 'categoryForm', 'categorySubmit' ]

  connect() {
    this._setFormListeners()
    this._setFrameListeners()
    this.debouncedChangeFrame = debounce(this.changeFrame.bind(this), 500)

    // На страницах услуг и категорий активной вкладкой рендерится текущая категория
    const currentCategoryId = this.element.dataset.currentCategoryId
    if (currentCategoryId) {
      this.currentFrame = this.categoryFrameTargets.find(
        frame => frame.dataset.categoryId == currentCategoryId
      ) || this.categoryFrameTargets[0]
      this.currentForm = this.categoryFormTargets.find(
        form => form.dataset.categoryId == currentCategoryId
      ) || this.categoryFormTargets[0]
    } else {
      this.currentFrame = this.categoryFrameTargets[0]
      this.currentForm = this.categoryFormTargets[0]
    }

    // Подгружаем и показываем первую активную вкладку
    this.currentFrame.classList.remove('hidden')
    this.currentForm.classList.add('active')
    this.currentForm.requestSubmit()
  }

  changeFrame(e) {
    const form = e.target.form
    this._switchForm(form)
    // Действие происходит и по наведению, и по нажатию,
    // но сабмит формы на получение фрейма делаем только в конце этой функции
    if (e.type === 'click') {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
    if (form.dataset.categoryId === this.currentFrame.categoryId) { return }

    // Если фрейм уже подгружен, просто делаем его видимым
    if (form.dataset.status === 'loaded') {
      this._switchToCategory(form.dataset.categoryId)
    } else if (form.dataset.status !== 'loading') {
      // Загружаем фрейм с помощью турбо
      form.requestSubmit()
    }
  }

  // Подсвечиваем кнопку категории, на которую навёл пользователь
  _switchForm(form) {
    this.currentForm.classList.remove('active')
    this.currentForm = form
    this.currentForm.classList.add('active')
  }

  _switchToCategory(categoryId) {
    if (this.currentFrame.dataset.categoryId == categoryId) { return }

    const newFrame = this.categoryFrameTargets.find(frame => frame.dataset.categoryId == categoryId )
    this.currentFrame.classList.add('hidden')
    this.currentFrame = newFrame
    this.currentFrame.classList.remove('hidden')
  }

  _switchToFrame(frame) {
    if (this.currentFrame === frame) { return }

    this.currentFrame.classList.add('hidden')
    this.currentFrame = frame
    this.currentFrame.classList.remove('hidden')
  }
  
  _setFormListeners() {
    this.categoryFormTargets.forEach(form => {
      form.addEventListener('turbo:submit-start', _e => {
        form.dataset.status = 'loading'
      })
      form.addEventListener('turbo:submit-end', _e => {
        form.dataset.status = 'loaded'
      })
    })

    this.categorySubmitTargets.forEach(submitBtn => {
      addDelayedMouseover(submitBtn, 500, this.changeFrame.bind(this))
    })
  }

  // Активная вкладка автоматически переключается после подгрузки фрейма
  _setFrameListeners() {
    this.categoryFrameTargets.forEach(frame => {
      frame.addEventListener('turbo:frame-load', _e => {
        this._switchToFrame(frame)
      })
    })
  }
}
